/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    areaCount,
    categoryCount,
    categoryList,
    categorySelectionList,
    categoryWithSubList,
} from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getAppHeaders, getSellerReadOnlyUrl, getSellerUrl } from 'shared/http';


class CategoryService {
    constructor() {
        this.service = interfaceService.getService();
    }

    getCategoryList() {
        return this.service.get(getSellerReadOnlyUrl(categoryList), getAppHeaders());
    }

    getCategoryCount(data) {
        return this.service.post(getSellerReadOnlyUrl(categoryCount), JSON.stringify(data), getAppHeaders());
    }

    getAreaCount(data) {
        return this.service.post(getSellerUrl(areaCount), JSON.stringify(data), getAppHeaders());
    }

    getCategoryWithSubList() {
        return this.service.get(getSellerReadOnlyUrl(categoryWithSubList), getAppHeaders());
    }

    getCategorySelectionList() {
        return this.service.get(getSellerReadOnlyUrl(categorySelectionList), getAppHeaders());
    }
}

export default new CategoryService();